import React from 'react';
import PropTypes from 'prop-types';

const OrganicShapeA = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 877 701">
      <path
        fill={props.color}
        d="M233.620198,125.612616 L0,326.115865 C66.807355,430.131065 103.61123,482.138665 110.411624,482.138665 C117.212018,482.138665 236.986607,555.092444 469.735392,701 L580.459903,468.256147 L876.09895,412.096736 L524.57942,99.0372285 L287.401553,0 L233.620198,125.612616 Z"
      />
    </svg>
  );
};

OrganicShapeA.defaultProps = {
  color: '#000000',
};

OrganicShapeA.propTypes = {
  color: PropTypes.string,
};

export default OrganicShapeA;
